// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
// import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
// import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import cityReducer from 'redux/reducer/cityReducer';
import stateReducer from 'redux/reducer/stateReducer';
import districtReducer from 'redux/reducer/DistrictReducer';
import employeeDesignationReducer from 'redux/reducer/EmployeeDesignationReducer';
import CommonReducer from 'redux/reducer/CommonReducer';
import employeeReducer from 'redux/reducer/employeeReducer';
import customerReducer from 'redux/reducer/customerReducer';
import producttypeReducer from 'redux/reducer/producttypeReducer';
import BrandReducer from 'redux/reducer/BrandReducer';
import BrandTargetReducer from 'redux/reducer/BrandTargetReducer';
import CategoryReducer from 'redux/reducer/CategoriesReducer';
import productReducer from 'redux/reducer/productReducer';
import orderReducer from 'redux/reducer/orderReducer';
import calenderReducer from 'redux/reducer/monthlycalenderReducer';
import manualAttendanceReducer from 'redux/reducer/manualattendanceReducer';
import leaveRequestReducer from 'redux/reducer/leaverequestReducer';
import paymentReducer from 'redux/reducer/paymentReducer';
import paymentReminderReducer from 'redux/reducer/PaymentReminderReducer';
import expenseReducer from 'redux/reducer/ExpenseReducer';
import ExpenseEntryReducer from 'redux/reducer/ExpenseEntryReducer';
import reportReducer from 'redux/reducer/RepotsReducer';
import purchaseorderReducer from 'redux/reducer/purchaseorderReducer';
import MonthlyPlannerReducer from 'redux/reducer/MonthlyplannerReducer';
import InvoiceReducer from 'redux/reducer/invoiceReducer';
import PasswordReducer from 'redux/reducer/PasswordReducer';
import QuotationReducer from 'redux/reducer/QuotationReducer'
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'berry-'
        },
        cartReducer
    ),
    kanban: kanbanReducer,
    // customer: customerReducer,
    contact: contactReducer,

    getallproduct: productReducer,
    product: productReducer,
    branddropdown : productReducer,
    categorydropdown : productReducer,
    producttypedropdown : productReducer,
    employeedesignation : employeeDesignationReducer,
    filterempbydesig : employeeDesignationReducer,

    productmessage: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,

    

    city: cityReducer,
    citiesmessage : cityReducer,
    creditdaysdropdown : cityReducer,
    district : districtReducer,
    districtmessage : districtReducer,
    
    brand : BrandReducer,
    brandmessage : BrandReducer,

    brandTarget : BrandTargetReducer,
    brandTargetmessage : BrandTargetReducer,
    
    category : CategoryReducer,
    categorymessage : CategoryReducer,

    producttype : producttypeReducer,
    producttypemessage : producttypeReducer,

    leavedata : leaveRequestReducer,
    changelog : leaveRequestReducer,

    state: stateReducer,
    statemessage : stateReducer,
    

    employee : employeeReducer,
    employeemessage : employeeReducer,
    allempemailid : employeeReducer,
    allempmobileno : employeeReducer,

    customer: customerReducer,
    customermessage : customerReducer,
    allemailid : customerReducer,
    allgstnumber : customerReducer,

    company: CommonReducer,
    designation: CommonReducer,
    paymentmode: CommonReducer,
    accountyear : CommonReducer,
    allcustomer : CommonReducer,
    uom : CommonReducer,

    order : orderReducer,
    paymentnotcompletedorder : orderReducer,
    singleorder : orderReducer,
    ordermessage : orderReducer,

    quotation: QuotationReducer,
    singlequotation : QuotationReducer,
    quotationmessage : QuotationReducer,

    calender : calenderReducer,
    calendermessage : calenderReducer,
    manualattendance : manualAttendanceReducer,
    manualmessage : manualAttendanceReducer,
    allempname : manualAttendanceReducer,
    payment:paymentReducer,
    paymentmessage:paymentReducer,
    paymentreminder:paymentReminderReducer,
    report : reportReducer,
    customerreport : reportReducer,
    locationreport : reportReducer,
    paymentreport : reportReducer,
    orderreport : reportReducer,
    attendancereport : reportReducer,
    targetreport : reportReducer,
    ledgerreport : reportReducer,
    daybookreport : reportReducer,
    punchinreport : reportReducer,
    stockreport : reportReducer,
    dailyentriesreport : reportReducer,
    expensereport : reportReducer,
    brandwisereport : reportReducer,
    pendingpurchaseorderreport : reportReducer,
    bometricreport: reportReducer,
    deliveryreport: reportReducer,

    expense : expenseReducer,
    expensedropdown : expenseReducer,
    expensemessage : expenseReducer,
    purchaseorder : purchaseorderReducer,
    purchaseordermessage : purchaseorderReducer,
    singlepurchaseorder : purchaseorderReducer,
    pendingpo : purchaseorderReducer,
    monthlyplantitle : MonthlyPlannerReducer,
    getmonthplanbydate : MonthlyPlannerReducer,
    monthlyplannermessage : MonthlyPlannerReducer,
    expensesEntry : ExpenseEntryReducer,
    expenseEntrymessages : ExpenseEntryReducer,
    invoice : InvoiceReducer,
    invoicemessage : InvoiceReducer,
    singleinvoice : InvoiceReducer,

    password :PasswordReducer,
    
});

export default reducer;
